var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import paths from './paths';
import metaTags from './metaTags';
import Footer, { MobileFooter } from '../shared/footer/footer';
import Account from "../pages/account/account";
import Help from "../pages/help/help";
import Announcements from "../pages/announcements/announcements";
import SportsBook from "../pages/sportsbook/sportsbook";
import LoginPage from "../pages/login/login";
import Notification from '../pages/notifications/notifications';
import NotificationDetail from '../pages/notifications/notification.detail';
import { useAuthContext } from "../store/login.store";
import { FlatPage } from "../pages/flatpages/flatpage";
import Home from "../pages/home/home";
import { betSlipVisibleSubject } from "../store/betslip.store";
import { useTranslation } from "react-i18next";
import { isMobileView } from "../app";
import { Game } from "../pages/games/game";
import { GameDetail } from "../pages/games/game.detail";
import UserCoupon from "../pages/userCoupon/user.coupon";
import NewHeader from "../shared/header/new-header";
import NewBetSlip from "../shared/betslip/new-betslip";
var ScrollToTop = function () {
    var pathname = useLocation().pathname;
    var parentPath = String(pathname);
    if (pathname.includes('sports') && (pathname.includes('tumu') || pathname.includes('canli') || pathname.includes('uzunvadeli'))) {
        parentPath = String(pathname).split('/').slice(0, 4).join('/');
    }
    useEffect(function () {
        if (pathname.includes('profil')) {
            // @ts-ignore
            document.getElementsByTagName('meta').robots.content = 'no-index, noindex, nofollow, no-follow';
        }
        else {
            // @ts-ignore
            document.getElementsByTagName('meta').robots.content = 'index, follow';
        }
        if (!parentPath.includes("sports")) {
            var root = document.getElementById('root');
            root.classList.remove("prematch");
            root.classList.remove("sportsbook");
            root.classList.remove("betslip-Fixed");
            root.classList.remove("compact-footer");
            // if (parentPath == '/') {
            //     if (!root.classList.includes('is-home-page')) {
            //         root.classList.add('is-home-page');
            //     }
            // }
            betSlipVisibleSubject.next(false);
        }
        else {
            var root = document.getElementById('root');
            root.classList.remove("betslip-Full");
            root.classList.add("betslip-Hidden");
            if (!isMobileView) {
                betSlipVisibleSubject.next(true);
            }
        }
        // if (pathname == 'oyun'){
        //     gameSettings.detailOpen = true;
        //     gameDetailSubject.next(true);
        // }else{
        //     gameSettings.detailOpen = false;
        //     gameDetailSubject.next(true);
        //
        // }
    }, [parentPath]);
    useEffect(function () {
        try {
            // @ts-ignore
            var metaTag = metaTags.find(function (x) { return x.path == parentPath.split("/")[1]; });
            if (!metaTag) {
                // @ts-ignore
                metaTag = metaTags.find(function (x) { return x.path == "/"; });
            }
            document.title = metaTag.title;
            // @ts-ignore
            document.getElementsByTagName('meta').description.content = metaTag.description;
            // @ts-ignore
            document.getElementsByTagName('meta').keywords.content = metaTag.keywords;
        }
        catch (e) {
        }
        window.scrollTo(0, 0);
    }, [parentPath]);
    return null;
};
var AppRoutes = function () {
    var _a = useAuthContext(), isAuthenticated = _a.isAuthenticated, setIsAuthenticated = _a.setIsAuthenticated;
    var i18n = useTranslation().i18n;
    var base = '/' + i18n.resolvedLanguage;
    return (_jsx(_Fragment, { children: isAuthenticated
            ? _jsxs(Router, { children: [_jsx(ScrollToTop, {}, void 0), _jsx(NewHeader, {}, void 0), _jsxs("div", __assign({ id: "content-holder", className: "layout-content-holder-bc" }, { children: [_jsxs(Routes, { children: [_jsx(Route, { path: "".concat(base, "/").concat(paths.NOTIFICATIONS, "/:id"), element: _jsx(NotificationDetail, {}, void 0) }, void 0), _jsx(Route, { path: "".concat(base, "/").concat(paths.NOTIFICATIONS), element: _jsx(Notification, {}, void 0) }, void 0), _jsx(Route, { path: "".concat(base, "/").concat(paths.HOME), element: _jsx(Home, {}, void 0) }, void 0), _jsx(Route, { path: "".concat(base, "/").concat(paths.LOGIN), element: _jsx(LoginPage, {}, void 0) }, void 0), _jsxs(Route, __assign({ path: "".concat(base, "/").concat(paths.ACCOUNT), element: _jsx(Account, {}, void 0) }, { children: [_jsx(Route, { path: ":subpage", element: _jsx(Account, {}, void 0) }, void 0), _jsx(Route, { path: ":subpage/:couponId", element: _jsx(Account, {}, void 0) }, void 0)] }), void 0), _jsx(Route, { path: "".concat(base, "/").concat(paths.HELP, "/:page"), element: _jsx(Help, {}, void 0) }, void 0), _jsx(Route, { path: "".concat(base, "/").concat(paths.FLATPAGES, "/:slug"), element: _jsx(FlatPage, {}, void 0) }, void 0), _jsx(Route, { path: "".concat(base, "/").concat(paths.ANNOUNCEMENTS), element: _jsx(Announcements, {}, void 0) }, void 0), _jsx(Route, { path: "".concat(base, "/").concat(paths.GAMES), element: _jsx(Game, { isLiveGame: false }, void 0) }, void 0), _jsx(Route, { path: "".concat(base, "/").concat(paths.LIVEGAMES), element: _jsx(Game, { isLiveGame: true }, void 0) }, void 0), _jsx(Route, __assign({ path: "".concat(base, "/").concat(paths.GAME), element: _jsx(GameDetail, {}, void 0) }, { children: _jsx(Route, { path: ":gameCode", element: _jsx(GameDetail, {}, void 0) }, void 0) }), void 0), _jsxs(Route, __assign({ path: "".concat(base, "/").concat(paths.SPORTSBOOK), element: _jsx(SportsBook, {}, void 0) }, { children: [_jsx(Route, { path: ":sportSlug/:eventType", element: _jsx(SportsBook, {}, void 0) }, void 0), _jsx(Route, { path: ":sportSlug/:eventType/:competitionId", element: _jsx(SportsBook, {}, void 0) }, void 0), _jsx(Route, { path: ":sportSlug/:eventType/:competitionId/:eventId", element: _jsx(SportsBook, {}, void 0) }, void 0)] }), void 0), _jsx(Route, { path: '/cs/user-coupon/:token/:couponId', element: _jsx(UserCoupon, {}, void 0) }, void 0), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: '' + base + '/', replace: true }, void 0) }, void 0)] }, void 0), _jsx("div", __assign({ className: "popup-holder-bc windowed hidden content-manager " }, { children: _jsx("div", __assign({ className: "popup-middleware-bc" }, { children: _jsx("div", __assign({ className: "popup-inner-bc" }, { children: _jsx("i", { className: "e-p-close-icon-bc bc-i-close-remove" }, void 0) }), void 0) }), void 0) }), void 0)] }), void 0), _jsx(Footer, {}, void 0), _jsx(MobileFooter, {}, void 0), isMobileView && _jsx(NewBetSlip, {}, void 0)] }, void 0)
            : _jsx(Router, { children: _jsxs(Routes, { children: [_jsx(Route, { path: '/cs/user-coupon/:token/:couponId', element: _jsx(UserCoupon, {}, void 0) }, void 0), _jsx(Route, { path: '*', element: _jsx(LoginPage, {}, void 0) }, void 0)] }, void 0) }, void 0) }, void 0));
};
export default AppRoutes;
